/* istanbul ignore file */
import { ApolloLink } from '@apollo/client';

import { getCredential } from 'common/auth/credential';

const authLink = new ApolloLink((operation, forward) => {
  const credential = getCredential();

  operation.setContext({
    headers: {
      authorization: credential
        ? `${credential.type} ${credential.accessToken}`
        : '',
    },
  });

  return forward(operation);
});

export default authLink;
